import React, { useState } from "react";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";

interface DownloadModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const DownloadModal: React.FC<DownloadModalProps> = ({ isOpen, onClose }) => {
  const [selectedOption, setSelectedOption] = useState<string>("");

  if (!isOpen) return null;

  const handleOk = () => {
    if (selectedOption) {
      // Prepare data for export
      const exportData = [{}];

      // Set headers based on selected option
      const headers =
        selectedOption === "QC Error"
          ? ["ReasonCode", "ErrorType", "ErrorCategory", "ErrorSubCategory"]
          : ["ReasonCode", "Query", "Role", "DocumentType"];

      // Create worksheet
      const worksheet = XLSX.utils.json_to_sheet(exportData, {
        header: headers,
      });
      const workbook = XLSX.utils.book_new();
      if (selectedOption === "QC Error") {
        XLSX.utils.book_append_sheet(
          workbook,
          worksheet,
          "ReasonCodeErrorType"
        );
        // Write file
        XLSX.writeFile(workbook, "ReasonCodeErrorType.xlsx");
      } else {
        XLSX.utils.book_append_sheet(
          workbook,
          worksheet,
          "ReasonCodeException"
        );
        // Write file
        XLSX.writeFile(workbook, "ReasonCodeException.xlsx");
      }

      // Close modal
      onClose();
    } else {
      toast.error("Please select an option before proceeding.", {
        theme: "colored",
      });
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50">
      <div className="bg-white p-4 rounded shadow-lg">
        <h2 className="text-lg font-bold mb-4">Reason Type Selection</h2>
        <div className="flex items-center mb-4">
          <input
            type="radio"
            id="exception"
            name="option"
            value="Exception"
            checked={selectedOption === "Exception"}
            onChange={(e) => setSelectedOption(e.target.value)}
            className="mr-2"
          />
          <label htmlFor="exception">Exception</label>
        </div>
        <div className="flex items-center mb-4">
          <input
            type="radio"
            id="qc-error"
            name="option"
            value="QC Error"
            checked={selectedOption === "QC Error"}
            onChange={(e) => setSelectedOption(e.target.value)}
            className="mr-2"
          />
          <label htmlFor="qc-error">QC Error</label>
        </div>
        <div className="flex justify-end gap-4">
          <button
            onClick={onClose}
            className="bg-gray-300 text-gray-800 py-2 px-4 rounded"
          >
            Cancel
          </button>
          <button
            onClick={handleOk}
            className="bg-blue-500 text-white py-2 px-4 rounded"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default DownloadModal;
